export const BRAND_THEME = {
  DEFAULT: "default",
  KRAKEN: "kraken",
  CRYPTOCOM: "cryptocom",
  COINBASE: "coinbase",
  LBANK: "lbank",
} as const;

export type BrandTheme = (typeof BRAND_THEME)[keyof typeof BRAND_THEME];

export const THEME_CLASS = {
  [BRAND_THEME.CRYPTOCOM]: "theme-cryptocom",
  [BRAND_THEME.KRAKEN]: "theme-kraken",
  [BRAND_THEME.COINBASE]: "theme-coinbase",
  [BRAND_THEME.LBANK]: "theme-lbank",
} as const;

export const ALL_THEME_CLASSES = Object.values(THEME_CLASS);
